import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow} from "@react-google-maps/api";
import { useUser } from "../hooks/useUser";
import "../styles/global.css";
import "../styles/Trees.css";
import mapStyles from "../styles/mapStyles"; // Import map styles
import Flight from "./Flight";

function Trees() {
  const [defaultCenter, setDefaultCenter] = useState({ lat: 34.0522, lng: -120.2437 });
  const [markers, setMarkers] = useState([]); // Track markers for flights
  const [selectedMarker, setSelectedMarker] = useState(null); // Track the selected marker for InfoWindow
  const { user, loading, error } = useUser();
  console.log(user, loading, error);
  let data = [];
  const [center, setCenter] = useState(defaultCenter);
  const [centerInitialized, setCenterInitialized] = useState(false);
  
  // Handle geolocation on initial render
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setCenterInitialized(true);
        },
        () => {
          console.log("Geolocation permission denied or unavailable.");
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // Function to check if the center has changed significantly
  const hasCenterChangedSignificantly = (newCenter, lastCenter) => {
    const distance = Math.sqrt(
      Math.pow(newCenter.lat - lastCenter.lat, 2) + Math.pow(newCenter.lng - lastCenter.lng, 2)
    );
    console.log("Distance:", distance);
    return distance > 1; // Adjust the threshold as needed
  };

  // Fetch flight data and update markers
  const fetchFlightData = async () => {
    if (!centerInitialized || !hasCenterChangedSignificantly(center, defaultCenter)) return;

    setDefaultCenter(center); // Update the default center once it's significantly changed
    console.log("Fetching flight data...");

    try {
      await Flight(data, center); // Assuming Flight returns flight data
      console.log(data);

      // Map flight data to markers
      const newMarkers = data.map(flight => ({
        callsign: flight.callsign,
        lat: flight.lat,
        lng: flight.lon,
        alt: flight.alt,
      }));
      data = []; // Clear the data array

      // Update markers in one call
      setMarkers(newMarkers);
    } catch (err) {
      console.error("Failed to fetch flight data:", err);
    }
  };

  // Set up the interval to fetch flight data every 5 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchFlightData(); // Fetch flight data every 5 seconds
    }, 5000); // 5000 ms = 5 seconds

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [center, centerInitialized]); // Effect depends on center and centerInitialized

  const mapContainerStyle = {
    height: "500px",
    width: "100%",
  };

  const locationIcon = {
    path: "M 10, 2 A 8, 8, 0, 1, 0, 10, 18 A 8, 8, 0, 1, 0, 10, 2 Z",
    fillColor: "blue",
    fillOpacity: 0.8,
    strokeColor: "blue",
    strokeWeight: 1,
    scale: 1,
  };

  const customIconUrl = "./new-plane.png"; // Replace with your custom icon URL

  return (
    <div>
      <h1>Flight Radar/Noise Finder</h1>
      <LoadScript
        googleMapsApiKey="AIzaSyCczeTeYhxhJo-BPa3A0ohg2q6lOM3MopQ"
        libraries={["visualization"]}
      >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={10}
          options={{
            disableDefaultUI: true,
            styles: mapStyles,
          }}
        >
           <Marker position={center} icon={locationIcon} />

{markers.map((marker, index) => (
  <Marker
    key={index}
    position={{ lat: marker.lat, lng: marker.lng }}
    icon={{
      url: customIconUrl, // Use the PNG image URL for the marker icon
      scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
    }}
    onClick={() => {
      console.log("Marker clicked:", marker);
      setSelectedMarker(marker)}} // Set the clicked marker as selected
  />
))}

{selectedMarker && (
  <InfoWindow
    position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
    onCloseClick={() => setSelectedMarker(null)}
  >
    <div style={{ color: 'black', fontSize: '10px', lineHeight: '0.8' }}>
        <p>Callsign: {selectedMarker.callsign}</p>
        <p>Latitude: {selectedMarker.lat}</p>
        <p>Longitude: {selectedMarker.lng}</p>
        <p>Altitude: {selectedMarker.alt} feet</p>
    </div>
  </InfoWindow>
)}

</GoogleMap>
</LoadScript>
</div>
);
}

export default Trees;
